import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { CardModule } from "primeng/card";
import { QR2ReportsDto } from "../../../../core/models/dashboard/qr2ReportsDto";
import { QR3ReportsDto } from "../../../../core/models/dashboard/qr3ReportsDto";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetOpenClientCreditsResponse } from "../../../../core/models/reports/getOpenClientCreditsResponse";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { OrderListingPaginatedService } from "../../../../core/services/order-listing-paginated.service";
import { OrdersListingService } from "../../../../core/services/orders-listing.service";
import { ProjectWorkflowService } from "../../../../core/services/project-workflow.service";
import { ReportsService } from "../../../../core/services/reports.service";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { ReadyToBillDto } from "../../../../core/models/reports/readyToBillDto";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { PieChartComponent } from "../dashboard-graphs/pie-chart/pie-chart.component";
import { BarChartComponent } from "../dashboard-graphs/bar-chart/bar-chart.component";
import { MultiLineChartComponent } from "../dashboard-graphs/multi-line-chart/multi-line-chart.component";
import { QR1ReportsDto } from "../../../../core/models/dashboard/qr1ReportsDto";
import { QR3ReportsResponse } from "../../../../core/models/dashboard/qr3ReportsResponse";
import { QR2Reports } from "../../../../core/models/dashboard/qr2Reports";
import { HeaderService } from "../../../../core/services/header.service";

@UntilDestroy()
@Component({
  selector: "jni-new-dashboard",
  imports: [
    CommonModule,
    CardModule,
    PieChartComponent,
    BarChartComponent,
    MultiLineChartComponent,
  ],
  templateUrl: "./new-dashboard.component.html",
  styleUrl: "./new-dashboard.component.scss",
})
export class NewDashboardComponent implements OnInit, OnDestroy {
  totalProjectCount = 0;
  totalSalesTaskCount = 0;
  totalProductionTaskCount = 0;
  openClientCreditRecords: GetOpenClientCreditsResponse[] = [];
  totalOrdersCount = 0;
  invoicePostedthisMonth: QR3ReportsDto[] = [];
  qr2List: QR2ReportsDto[] = [];
  qr1List: ReadyToBillDto[] = [];
  qr4List: QR1ReportsDto[] = [];
  validateLoginRes!: ValidateLogin;

  constructor(
    private _userManagement: UserManagementService,
    private _workflowService: ProjectWorkflowService,
    private _taskManagement: TaskManagementService,
    private _reportsService: ReportsService,
    private _orderListingService: OrdersListingService,
    private _orderListingPaginatedService: OrderListingPaginatedService,
    private _dashboardService: DashboardService,
    private _headerService: HeaderService
  ) {
    this._headerService.headerTagsVisibility(false);
  }

  ngOnInit() {
    this.validateLogin();
    this.getTotalProjectWorkflows();
    this.getTotalTask();
    this.getOpenClientCreditRecords();
    this.getReadyToBillReport();
    this.getCustomerAging();
    this.getOrdersBilledInvoiced();
    this.getOrdersWrittenthismonth();
  }

  validateLogin(): void {
    this._userManagement.validateLogin().subscribe({
      next: (res: GenericResponseDto<ValidateLogin>) => {
        this.validateLoginRes = res.data;
        this.getOrdersTotalCount();
      },
      error: err => {
        //this.showLoader = false;
        console.error("jniportal-validateLogin", err);
      },
    });
  }

  getTotalProjectWorkflows() {
    const request = {
      skip: 0,
      take: 1000,
      filters: [],
      sort: [],
      workflowListStatus: "0",
      workflowStatusId: 0,
      customerAccountNumber: "",
      isCustomFilter: false,
      archiveWorkflowStatusId: 0,
      archivedProject: false,
    };

    this._workflowService
      .getAllWorkflows(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.totalProjectCount = res.totalRecords ?? 0;
          }
        },
      });
  }

  getTotalTask() {
    const request = {
      skip: 0,
      take: 1000,
      filters: [
        {
          columnName: "Id",
          matchMode: "equals",
          tableName: "workflowheaders",
          value: "",
        },
        {
          columnName: "RemindMe",
          matchMode: "equals",
          tableName: "UserTasks",
          value: "",
        },
        {
          columnName: "Name",
          matchMode: "equals",
          tableName: "Tags",
          value: "",
        },
      ],
      sort: [],
      listViewType: 1,
      myTask: true,
      userTimeZone: "Asia/Karachi",
      archivedTask: false,
    };

    this._taskManagement
      .getAllProjectWorkFlowTaskList(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.totalSalesTaskCount = res.data.filter(
              x => x.taskType === 1
            ).length;
            this.totalProductionTaskCount = res.data.filter(
              x => x.taskType === 2
            ).length;
          }
        },
      });
  }

  getOpenClientCreditRecords() {
    this._reportsService
      .getOpenClientCreditsReport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.openClientCreditRecords = res.data;
          }
        },
      });
  }

  getOrdersTotalCount() {
    if (this.validateLoginRes?.userRoleId === UserRole.Admin) {
      const request = {
        skip: 0,
        take: 25,
        filters: [],
        sort: [],
        status: "All",
        isSimpleOrderSearch: false,
        orderCreatedDateFilterCriteria: "between",
        isInventorySales: false,
      };
      this._orderListingPaginatedService
        .getAllSaleOrders(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.totalOrdersCount = res.totalRecords ?? 0;
            }
          },
        });
    } else {
      const request = {
        skip: 0,
        take: 0,
        filters: [],
        sort: [
          {
            field: "createdDate",
            order: 1,
          },
        ],
        fromDate: "2025-08-14T00:00:00.000Z",
        toDate: "2025-08-14T00:00:00.000Z",
        isSimpleOrderSearch: false,
        orderCreatedDateFilterCriteria: "",
        isInventorySales: false,
      };

      this._orderListingService
        .getAllSaleOrders(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.totalOrdersCount = res.data.length ?? 0;
            }
          },
        });
    }
  }

  getReadyToBillReport() {
    this._dashboardService
      .getReadyToBillReport(0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<ReadyToBillDto[]>) => {
          if (res.data) {
            this.qr1List = res.data;
          }
        },
      });
  }

  getCustomerAging() {
    this._dashboardService
      .getCustomerAging(0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR1ReportsDto[]>) => {
          if (res.data) {
            this.qr4List = res.data;
          }
        },
      });
  }

  getOrdersBilledInvoiced() {
    this._dashboardService
      .getOrdersBilledInvoiced(0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR3ReportsResponse>) => {
          if (res.data) {
            this.invoicePostedthisMonth = res.data.qR3ReportsDto ?? [];
          }
        },
      });
  }

  getOrdersWrittenthismonth() {
    this._dashboardService
      .getOrdersWrittenthismonth(0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR2Reports>) => {
          if (res?.data) {
            this.qr2List = res.data.qR2ReportsDtos ?? [];
          }
        },
      });
  }

  ngOnDestroy() {
    this._headerService.headerTagsVisibility(true);
  }
}
